var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBusiness = function SvgBusiness(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_63696_254283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.9987 4.66667V2H1.33203V14H14.6654V4.66667H7.9987ZM3.9987 12.6667H2.66536V11.3333H3.9987V12.6667ZM3.9987 10H2.66536V8.66667H3.9987V10ZM3.9987 7.33333H2.66536V6H3.9987V7.33333ZM3.9987 4.66667H2.66536V3.33333H3.9987V4.66667ZM6.66536 12.6667H5.33203V11.3333H6.66536V12.6667ZM6.66536 10H5.33203V8.66667H6.66536V10ZM6.66536 7.33333H5.33203V6H6.66536V7.33333ZM6.66536 4.66667H5.33203V3.33333H6.66536V4.66667ZM13.332 12.6667H7.9987V11.3333H9.33203V10H7.9987V8.66667H9.33203V7.33333H7.9987V6H13.332V12.6667ZM11.9987 7.33333H10.6654V8.66667H11.9987V7.33333ZM11.9987 10H10.6654V11.3333H11.9987V10Z",
    fill: "#80859F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_63696_254283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBusiness);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "business.9bb14a96d3d491c31e026833cf31dced.svg";